import { DateFormatConstants } from '@application/common/constants/date-format';
import { formateDate } from '@application/common/helpers/date-time-helper';
import moment from 'moment';
export const convertModelToFormData = (data, form = new FormData(), namespace = '') => {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || !data[propertyName])
            continue;
        if (data[propertyName] instanceof Array) {
            if (data[propertyName].every((x) => x instanceof File)) {
                files[propertyName] = data[propertyName];
            }
            else {
                model[propertyName] = data[propertyName];
            }
        }
        else if (data[propertyName] instanceof File || data[propertyName]) {
            files[propertyName] = data[propertyName];
        }
        else {
            model[propertyName] = data[propertyName];
        }
    }
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date) {
            formData.append(formKey, moment(model[propertyName]).format("yyyy-MM-DD"));
        }
        else if (model[propertyName] instanceof File) {
            formData.append(formKey, model[propertyName]);
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === 'object') {
                    for (const property in element) {
                        if (element.hasOwnProperty(property)) {
                            const value = element[property];
                            if (value instanceof File) {
                                formData.append(`${tempFormKey}.${property}`, value);
                            }
                            else if (Array.isArray(value)) {
                                value.forEach((item, index) => {
                                    formData.append(`${tempFormKey}.${property}[${index}].`, item);
                                });
                            }
                            else if (typeof value === 'object' && value !== null) {
                                formData.append(`${tempFormKey}.${property}.`, value);
                            }
                            else {
                                formData.append(`${tempFormKey}.${property}`, value);
                            }
                        }
                    }
                }
                else
                    formData.append(tempFormKey, element.toString());
            });
        }
        else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
            convertModelToFormData(model[propertyName], formData, formKey);
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            if (files[propertyName] instanceof Array) {
                files[propertyName].forEach((element) => {
                    formData.append(propertyName, element);
                });
            }
            else if (files[propertyName] instanceof Date) {
                formData.append(propertyName, formateDate(files[propertyName], DateFormatConstants.YMD));
            }
            else
                formData.append(propertyName, files[propertyName]);
        }
    }
    return formData;
};
export function convertToFormData(dto, formData, tempFormKey) {
    const appendProperties = (prefix, obj) => {
        for (const property in obj) {
            if (obj.hasOwnProperty(property)) {
                const value = obj[property];
                if (value instanceof File) {
                    formData.append(`${prefix}${property}`, value);
                }
                else if (Array.isArray(value)) {
                    value.forEach((item, index) => {
                        formData.append(`${prefix}${property}[${index}].`, item);
                    });
                }
                else if (typeof value === 'object' && value !== null) {
                    formData.append(`${prefix}${property}.`, value);
                }
                else {
                    formData.append(`${prefix}${property}`, value);
                }
            }
        }
    };
    appendProperties(tempFormKey, dto);
    return formData;
}
